/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    /**
     * Factory callback type
     */
    declare type SidebarPrimaryToggleDirectiveFactoryCb = ($rootScope: ng.IRootScopeService,
                                                           $window: ng.IWindowService,
                                                           $timeout: ng.ITimeoutService) => SidebarPrimaryToggleDirective;

    interface ISidebarSecondaryToggleDirectiveScope extends ng.IScope {
        togglePrimarySidebar: ($event: IExtendedEvent) => void;
    }

    interface IExtendedEvent extends ng.IAngularEvent {
        currentTarget: Object;
    }

    export class SidebarPrimaryToggleDirective implements ng.IDirective {
        public static $name: string = 'sidebarPrimaryToggle';

        public link: ($scope: ng.IScope, $element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public transclude: boolean = false;
        public replace: boolean = true;
        public template: string = `<a id="sSwitch_primary" class="sSwitch sSwitch_left" ng-click="togglePrimarySidebar($event)">
                                        <img src="images/flex-ebu-eye-white.png" class="ebu_eye_switch"/>
                                        <!--span class="sSwitchIcon"></span-->
                                   </a>`;

        public static Factory(): SidebarPrimaryToggleDirectiveFactoryCb {
            let directive: SidebarPrimaryToggleDirectiveFactoryCb = ($rootScope: IFlexRootScope,
                                                                     $window: ng.IWindowService,
                                                                     $timeout: ng.ITimeoutService) => {
                return new SidebarPrimaryToggleDirective($rootScope, $window, $timeout);
            };
            directive.$inject = ['$rootScope', '$window', '$timeout'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor($rootScope: IFlexRootScope,
                    $window: ng.IWindowService,
                    $timeout: ng.ITimeoutService) {

            SidebarPrimaryToggleDirective.prototype.link = ($scope: ISidebarSecondaryToggleDirectiveScope,
                                                            $element: JQuery,
                                                            attrs: ng.IAttributes) => {
                $scope.togglePrimarySidebar = ($event: ng.IAngularEvent): void => {
                    $event.preventDefault();

                    if ($rootScope.primarySidebarActive) {
                        $rootScope.primarySidebarHiding = true;
                        if ($rootScope.largeScreen) {
                            $timeout(() => {
                                $rootScope.primarySidebarHiding = false;
                                angular.element($window).resize();
                            }, 290);
                        }
                    } else {
                        if ($rootScope.largeScreen) {
                            $timeout(() => {
                                angular.element($window).resize();
                            }, 290);
                        }
                    }

                    $rootScope.primarySidebarActive = !$rootScope.primarySidebarActive;

                    if ($rootScope.largeScreen) {
                        $rootScope.primarySidebarClosedByUser = (!$rootScope.primarySidebarActive) ? true : false;
                    }

                    if ($rootScope.primarySidebarOpen) {
                        $rootScope.primarySidebarOpen = false;
                        $rootScope.primarySidebarActive = false;
                    } else {
                        $rootScope.primarySidebarOpen = true;
                    }
                };
            };
        }
    }
}